import { ref, watch } from "vue";
import { useRouter } from "vue-router";

import { useUser } from "./api/useUser";

const mustRedirectAuthenticatedUser = ref(true);
const mustAvoidRedirectionOnRefresh = ref(true);

export function redirectionToJoinFidPage() {
  // STAGING
  if (window.location.hostname.includes("lactalis-opfid2025-lactel.numberly.st")) {
    window.location.href = "https://pp-v4-www.enviedebienmanger.fr/programme-lactel-club";
  }
  if (window.location.hostname.includes("lactalis-opfid2025-galbani.numberly.st")) {
    window.location.href = "https://pp-v4-www.enviedebienmanger.fr/programme-galbani";
  }

  // PRODUCTION
  if (window.location.hostname.includes("club.lactel.fr")) {
    window.location.href =
      "https://www.enviedebienmanger.fr/programme-lactel-club/?utm_source=autoredirect";
  }
  if (window.location.hostname.includes("topchef.galbani.fr")) {
    window.location.href =
      "https://www.enviedebienmanger.fr/programme-galbani/?utm_source=autoredirect";
  }
}

export function useRedirection() {
  const router = useRouter();
  const { data: user, isSuccess, isError, relogParams } = useUser();

  watch(isSuccess, async () => {
    if (isSuccess.value && user.value && mustRedirectAuthenticatedUser.value && !relogParams) {
      mustRedirectAuthenticatedUser.value = false;
      mustAvoidRedirectionOnRefresh.value = false;
      if (user.value.current_mechanic === "galbani") {
        await router.push({ name: "gifts" });
      }
      if (user.value.current_mechanic === "lactel") {
        await router.push({ name: "vouchers" });
      }
    }
  });

  watch(isError, async () => {
    if (isError.value && mustAvoidRedirectionOnRefresh.value) {
      redirectionToJoinFidPage();
    }
  });
}
